import { Spin } from 'antd'
import Alert from 'app/components/UI-Elements/Feedback/Alert'
import { RecordType } from 'app/constants/GlobalTypes'
import { ToolBox } from 'app/lib/hooks/toolBox'
import { useCreate } from 'app/lib/hooks/useApi'
import * as React from 'react'
import { useEffect } from 'react'

type Props = {
  rental_id: number
  onSuccess: () => void
}

const SolvencyCheck: React.FC<Props> = ({ rental_id, onSuccess }) => {
  const { tComponent } = ToolBox.useString()
  const { loading, execute } = useCreate(RecordType.solvency, null, true)

  useEffect(() => {
    execute({ rental_id }).then(({ data }: { data: { success: boolean } }) => {
      if (data.success) {
        onSuccess()
      }
    })
  }, [])

  const translate = (id: string) =>
    tComponent({
      componentName: 'check',
      componentType: 'core',
      recordType: RecordType.solvency,
      id
    })

  return (
    <Alert
      showIcon={true}
      type={'default'}
      message={loading ? translate('loading') : translate('error.title')}
      icon={loading && <Spin spinning />}
      description={
        <p>
          <If condition={!loading}>{translate('error.description')}</If>
        </p>
      }
    />
  )
}

export default SolvencyCheck
